<template>
  <div class="bg-card">
    <div class="d-flex justify-content-between">
      <strong>{{ $t('pages.intern-control.title') }}</strong>
      <div>
        <div>
          <div
            v-if="(offerApply.status === 'New' || offerApply.status === 'Seen') && $can('jobs_manage')"
            class="d-flex"
          >
            <b-button
              v-b-modal.modal-accept
              variant="success"
              class="status-change-btn"
            >
              {{ $t('pages.one-candidate.accept') }}
            </b-button>
            <b-button
              v-b-modal.modal-reject
              variant="danger"
              class="status-change-btn"
            >
              {{ $t('pages.one-candidate.reject') }}
            </b-button>
          </div>
          <div v-if="offerApply.status === 'Accepted'">
            <b-button
              variant="success"
              class="status-change-btn"
              disabled
              style="background-color: #008800 !important"
            >
              {{ $t('pages.one-candidate.accepted') }}
            </b-button>
          </div>
          <div v-if="offerApply.status === 'Rejected'">
            <b-button
              variant="danger"
              class="status-change-btn"
              disabled
              style="background-color: #ff0000 !important"
            >
              {{ $t('pages.one-candidate.rejected') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <hr>

    <!-- Comments -->
    <b-form-textarea
      id="textarea"
      v-model="comment"
      :placeholder="$t('inputs.comment.placeholder')"
      rows="3"
      max-rows="6"
      class="mb-2"
    />
    <b-button
      size="sm"
      variant="success"
      @click="saveComment"
    >
      {{ $t('pages.intern-control.title') }}
    </b-button>

    <!-- MODALS -->
    <div v-if="$can('jobs_manage')">
      <b-modal
        id="modal-accept"
        centered
        header-bg-variant="warning"
        :title="$t('pages.one-candidate.modal.title')"
        @ok="changeStatus(offerApply, 'Accepted')"
      >
        <p class="my-4">
          {{ $t('pages.one-candidate.modal-accept') }}
        </p>
      </b-modal>
      <b-modal
        id="modal-reject"
        centered
        header-bg-variant="warning"
        :title="$t('pages.one-candidate.modal.title')"
        @ok="changeStatus(offerApply, 'Rejected')"
      >
        <p class="my-4">
          {{ $t('pages.one-candidate.modal-reject') }}
        </p>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offerApply: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      comment: ""
    }
  },
  watch: {
    offerApply(oldValue, newValue) {
      if (oldValue.id !== newValue.id) {
        this.getInternOfferApply();
        if (newValue.status !== 'Accepted') {
          this.comment = "";
        }
      }
    }
  },
  mounted() {
    this.getInternOfferApply();
  },
  methods: {
    getInternOfferApply() {
      this.axios.get('/offerApply/getInternApply?offerId=' + this.offerApply.offer.id + '&offerApplyId=' + this.offerApply.id)
        .then( response => {
          this.comment = response.data.comment
        })
        .catch();
    },
    changeStatus(offerApply, currentStatus) {
      if (currentStatus === 'New') {
        currentStatus = 'Seen';
      } else if(currentStatus === 'Accepted') {
        currentStatus = 'Accepted';
      } else if(currentStatus === 'Rejected') {
        currentStatus = 'Rejected';
      } else {
        return;
      }
      this.axios.put('/offerApply/changeStatus/' + offerApply.id, { status: currentStatus })
        .then( response => {
          this.offerApply.status = response.data.status;

          if(this.offerApply.status === 'Rejected') {
            this.$emit('getNewCandidate');
          }
        })
        .catch();
    },
    saveComment() {
      let internOfferApply = {
        offerId: this.offerApply.offer.id,
        offerApplyId: this.offerApply.id,
        comment: this.comment
      };
      this.axios.put('/offerApply/intern/update', internOfferApply)
        .then( response => {
          this.comment = response.data.comment;
          this.$toastNotification('success', '', this.$t('pages.intern-control.update.success'));
        })
        .catch();
    }
  }
}
</script>

<style>
  .status-change-btn {
    padding: 3px 10px;
    font-size: 0.9rem;
    font-weight: 600;
    margin: 0 3px;
  }
</style>
